import { Box } from "@chakra-ui/react";
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";

import { PrivateRoute } from "src/components/navigation/PrivateRoute";
import { Footer } from "src/components/shared/Footer";

import { HomePage } from "./home";
import { NotFoundPage } from "./404";
import { LoginPage } from "./login";
import { CreateConversationPage } from "./conversation/create";
import { EditConversationPage } from "./conversation/edit";
import { ConversationHistoryPage } from "./conversation/history";
import { ConversationInvitationsPage } from "./conversation/invitations";
import { ConversationPage } from "./conversation/[conversationId]";
import { ConversationTopicPage } from "./conversation/[conversationId]/[topicId]";
import { ConversationAdminPage } from "./conversation/admin/ConversationAdminPage";
import { UsersAdminPage } from "./users";
import { ScriptsPage } from "./admin/Scripts";
import { CreateUserPage } from "./users/create";
import {
  MissionFormPage,
  MissionsAdminPage
} from "./missions";

export const AppRouter: React.FC = () => (
  <Router>
    <Box pb="48px">
      <Switch>
        <PrivateRoute
          path="/"
          exact
          component={HomePage}
        />

        <Route
          path="/login"
          exact
          component={LoginPage}
        />

        <PrivateRoute
          path="/conversation/create"
          exact
          component={CreateConversationPage}
        />

        <PrivateRoute
          path="/conversation/admin"
          exact
          component={ConversationAdminPage}
        />

        <PrivateRoute
          path="/conversation/:conversationId/edit"
          exact
          component={EditConversationPage}
        />

        <PrivateRoute
          path="/conversation/history"
          exact
          component={ConversationHistoryPage}
        />

        <PrivateRoute
          path="/conversation/invitations"
          exact
          component={ConversationInvitationsPage}
        />

        <PrivateRoute
          path="/conversation/:conversationId"
          exact
          component={ConversationPage}
        />

        <PrivateRoute
          path="/conversation/:conversationId/topic/:topicId"
          exact
          component={ConversationTopicPage}
        />

        <PrivateRoute
          path="/users"
          exact
          component={UsersAdminPage}
        />

        <PrivateRoute
          path="/users/create"
          exact
          component={CreateUserPage}
        />

        <PrivateRoute
          path="/missions/create"
          exact
          component={MissionFormPage}
        />

        <PrivateRoute
          path="/missions/:missionId/edit"
          exact
          component={MissionFormPage}
        />

        <PrivateRoute
          path="/missions"
          exact
          component={MissionsAdminPage}
        />

        <PrivateRoute
          path="/scripts"
          exact
          component={ScriptsPage}
        />

        <Route
          path="*"
          component={NotFoundPage}
        />
      </Switch>
    </Box>

    <Footer />
  </Router>
);
